// src/components/PendingInvite.js
import React from 'react';
import { formatExpiresAt, isExpired } from '../utils/dateUtils';
import '../styles/PendingInvite.css';
import { useToast } from './Toast';

const PendingInvite = ({ invite, onReissue, onCancel }) => {
    const toast = useToast();
    const expired = isExpired(invite.expiresAt);

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(invite.inviteCode);
            toast.success('초대 코드가 클립보드에 복사되었습니다!');
        } catch (error) {
            console.error('클립보드 복사 실패:', error);
            toast.error('클립보드 복사에 실패했습니다.');
        }
    };

    return (
        <section className="pending-invite-section">
            <div className="pending-invite-card">
                <h3>💌 매칭 대기 중</h3>
                <p>상대방이 아래 초대 코드를 입력하면 커플이 완성됩니다.</p>
                <div className="pending-code-display">
                    <span className="pending-code">{invite.inviteCode}</span>
                    <button onClick={copyToClipboard} className="pending-copy-btn">복사</button>
                </div>
                <p className={`pending-expires ${expired ? 'expired' : ''}`}>
                    {expired ? '코드가 만료되었어요. 재발급해주세요.' : formatExpiresAt(invite.expiresAt)}
                </p>
                <div className="pending-actions">
                    <button onClick={onReissue} className="pending-reissue-btn">코드 재발급</button>
                    <button onClick={onCancel} className="pending-cancel-btn">초대 취소</button>
                </div>
            </div>
        </section>
    );
};

export default PendingInvite;
